import { render, staticRenderFns } from "./KategoriTanimlama.vue?vue&type=template&id=0bdbb49d&scoped=true&"
import script from "./KategoriTanimlama.vue?vue&type=script&lang=js&"
export * from "./KategoriTanimlama.vue?vue&type=script&lang=js&"
import style0 from "./KategoriTanimlama.vue?vue&type=style&index=0&id=0bdbb49d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdbb49d",
  null
  
)

export default component.exports